class HeroBlockHeight {
    constructor() {
        this.InitHeroBlockHeight();
    }

    InitHeroBlockHeight() {
        const heroBlocks = document.querySelectorAll(".js-hero-block");

        if (heroBlocks.length !== 0) {
            setHeroBlockHeight(heroBlocks);
            window.onresize = function () {
                setHeroBlockHeight(heroBlocks);
            };
        }
    }
}

function setHeroBlockHeight(heroBlocks: NodeListOf<Element>) {
    heroBlocks.forEach((heroBlock) => {
        const block = heroBlock as HTMLElement;
        const heroImages = Array.from(
            heroBlock.querySelectorAll(".js-hero-image"),
        ) as HTMLElement[];

        const heroText = heroBlock.querySelector(
            ".js-hero-text",
        ) as HTMLElement;

        const padding = 40;

        if (heroText && heroImages && heroImages.length > 0) {
            heroImages.forEach((heroImage) => {
                heroImage.style.height = "";
            });

            const newHeight = heroText.offsetHeight + 2 * padding;

            if (block.offsetHeight < newHeight) {
                heroImages.forEach((heroImage) => {
                    heroImage.style.height = `${newHeight}px`;
                    heroImage.setAttribute("height", `${newHeight}`);
                    heroImage.setAttribute("width", `${heroImage.clientWidth}`);
                });
            }
        }
    });
}

export default HeroBlockHeight;
